'use client';

import type { ComponentPropsWithoutRef, ReactNode, Ref } from 'react';

import classnames from 'classnames';

import { activateOnKey } from '../../utils/keyboard';
import type { BaseComponentProps } from '../base-component.types';

import styles from './UserMenuItem.module.scss';

export type UserMenuItemProps = ComponentPropsWithoutRef<'li'> &
  BaseComponentProps & {
    children?: ReactNode;
    icon?: ReactNode;
    active?: boolean;
    prefix?: ReactNode;
    suffix?: ReactNode;
  };

export function UserMenuItem({
  style,
  children,
  className,
  icon,
  prefix,
  suffix,
  testId = 'ui-user-menu_item',
  ref,
  ...rest
}: UserMenuItemProps & { ref?: Ref<HTMLLIElement> }) {
  return (
    <li
      style={style}
      ref={ref}
      data-testid={testId}
      className={classnames(styles['user-menu-item'], className)}
      {...rest}
    >
      <div
        tabIndex={0}
        role="button"
        className={styles['inner-item']}
        onKeyDown={activateOnKey}
      >
        {icon ? (
          <span className={styles['icon-wrapper']}>
            <span className={styles['icon-wrapper__icon']}>{icon}</span>
          </span>
        ) : null}
        {prefix ? (
          <span className={styles['prefix-wrapper']}>{prefix}</span>
        ) : null}
        <span className={styles['item-content']}>{children}</span>
        {suffix ? (
          <span
            className={styles['suffix-wrapper']}
            onClick={(event: React.MouseEvent<HTMLElement>) => {
              event.stopPropagation();
            }}
          >
            {suffix}
          </span>
        ) : null}
      </div>
    </li>
  );
}
